@if (variant === 'strip') {
  <span class="colors-strip" aria-hidden="true">
    <span
      class="colors-strip-segment"
      [style.background]="color"
      *ngFor="let color of colorset.colors"></span>
  </span>
} @else {
  <span class="flex align-items-center gap-2">
    <i
      class="fas fa-circle"
      [style.color]="color"
      *ngFor="let color of colorset.colors"></i>
  </span>
}
